import { createSlice } from '@reduxjs/toolkit';
import { getCoursesAdmin, updateCourse, deleteCourse, addCourse, getCourseById } from './httpRequests';
// actualiza
const initialState = {
  courses: [],
  current: null,
  loading: false,
  error: null,
};

const courseSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    resetCourses(state) {
      state.courses = [];
      state.current = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // GET LIST
    builder
      .addCase(getCoursesAdmin.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(getCoursesAdmin.fulfilled, (s, a) => { s.loading = false; s.courses = a.payload || []; })
      .addCase(getCoursesAdmin.rejected, (s, a) => { s.loading = false; s.error = a.payload || 'Error al traer cursos'; });

    // GET ONE
    builder
      .addCase(getCourseById.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(getCourseById.fulfilled, (s, a) => { s.loading = false; s.current = a.payload || null; })
      .addCase(getCourseById.rejected, (s, a) => { s.loading = false; s.error = a.payload || 'Error al traer curso'; });

    // UPDATE
    builder
      .addCase(updateCourse.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(updateCourse.fulfilled, (s, a) => {
        s.loading = false;
        const doc = a.payload;          // esperamos un doc con _id (por el thunk de arriba)
        const id  = doc?._id;
        if (!id) return;

        const idx = s.courses.findIndex(c => c._id === id);
        if (idx !== -1) s.courses[idx] = doc;     // ✅ reemplazo duro
        if (s.current?._id === id) s.current = doc;
      })
      .addCase(updateCourse.rejected, (s, a) => { s.loading = false; s.error = a.payload || 'Error al actualizar curso'; });

    // DELETE
    builder
      .addCase(deleteCourse.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(deleteCourse.fulfilled, (s, a) => {
        s.loading = false;
        const id = a.payload._id;
        s.courses = s.courses.filter((c) => c._id !== id);
        if (s.current?._id === id) s.current = null;
      })
      .addCase(deleteCourse.rejected, (s, a) => { s.loading = false; s.error = a.payload || 'Error al eliminar curso'; });

    // ADD (si usás addCourse)
    builder
      .addCase(addCourse?.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(addCourse?.fulfilled, (s, a) => { s.loading = false; if (a.payload) s.courses.unshift(a.payload); })
      .addCase(addCourse?.rejected, (s, a) => { s.loading = false; s.error = a.payload || 'Error al crear curso'; });
  },
});

export const { resetCourses } = courseSlice.actions;
export default courseSlice.reducer;